import { render, staticRenderFns } from "./KPIForm.vue?vue&type=template&id=b07b06d4"
import script from "./KPIForm.vue?vue&type=script&lang=ts"
export * from "./KPIForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports